import { styled } from 'styled-components';

import { placeholder } from 'src/styles/mixins';

export const StyledCirclePlaceholder = styled.div`
  ${placeholder};
  border-radius: 100%;
`;
